import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { WebSphModule } from "./ui/root/websph.module";
//  enableProdMode();

platformBrowserDynamic().bootstrapModule(WebSphModule);
//platformBrowserDynamic().bootstrapModule(AppModule);
//platformBrowserDynamic().bootstrapModule(CommunicationModule);
//platformBrowserDynamic().bootstrapModule(RadioButtonsModule);



// WEBPACK FOOTER //
// D:/[Projects]/WebSPH.gits/WebSPH.git/src/main.ts